// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_fs","advertDetailHeaderPrice__value":"c-m_ft","advertDetailHeaderPrice__label":"c-m_fu"};